export const getSlideProjectName = () => {
  const is2xl = window.innerWidth >= 1736;
  const marginValue = is2xl ? "6.5rem" : "1rem";

  return {
    hidden: {
      marginLeft: "0rem",
      opacity: 1,
      transition: { duration: 0.3 },
    },
    visible: {
      marginLeft: marginValue,
      opacity: 0.6,
      transition: { duration: 0.3 },
    },
  };
};
